// extracted by mini-css-extract-plugin
export default {"container":"style_container__S4OfE","child":"style_child__j9Phr"};